/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios';
import { useState } from 'react';
import { createFile } from '@/api/fileUpload';
import { useGetDiscplines } from '@/api/hooks';
import { useCreateExam, useGetExams } from '@/api/hooks/useEpreuve';
import { EpreuveFormValues, useEpreuveForm } from '@/hooks/useEpreuve';
import { useFormatDate } from '@/hooks/useFormatDate';
import { useToast } from '@/hooks/useToast';
import { useDisciplineStore } from '@/store/DisciplineStore/DisciplineStore';
import { useExamStore } from '@/store/ExamStore/ExamStore';
import { ExamFilteredOutput } from '@/api/gql/graphql';

export const useEpreuve = () => {
  const [generateUrlLoading, setGenerateUrlLoading] = useState(false);
  const [seletedExam, setSeletedExam] = useState<ExamFilteredOutput | null>(
    null,
  );
  const { register, handleSubmit, errors, setValue, reset } = useEpreuveForm();
  const { selectedDiscipline } = useDisciplineStore();
  const { setIsOpenExamModal } = useExamStore();

  const { data: epreuveData, isLoading: loadingData } = useGetExams({
    disciplines: selectedDiscipline?._id,
  });
  const { data: disciplines } = useGetDiscplines();
  const { mutate: createExam, isPending: isCreatingExam } = useCreateExam();

  const { showToast } = useToast();
  const { formatDateYear } = useFormatDate();

  const onSubmit = async (data: EpreuveFormValues) => {
    try {
      setGenerateUrlLoading(true);
      const token = localStorage.getItem('authToken') ?? '';

      const fileUploadPromise = data.content
        ? axios(createFile(data.content, token)).then((response) => {
            if (response.status !== 201) {
              setGenerateUrlLoading(false);
              throw new Error("Erreur lors de l'ajout du fichier");
            }
            setGenerateUrlLoading(false);
            return response.data?.publicUrl || response.data;
          })
        : Promise.resolve(null);

      const fileUrl = await fileUploadPromise;

      createExam(
        {
          name: data.name,
          year: formatDateYear(data.year),
          discipline: data.discipline,
          content: fileUrl,
        },
        {
          onSuccess: () => {
            setGenerateUrlLoading(false);
            showToast('Epreuve créée', 'success', {
              autoClose: 5000,
              position: 'top-right',
            });
            setIsOpenExamModal(false);
            reset();
          },
          onError: (error) => {
            setGenerateUrlLoading(false);
            showToast(error?.message, 'error', {
              autoClose: 5000,
              position: 'top-right',
            });
          },
        },
      );
    } catch (error) {
      console.error('Error:', error);
    }
  };

  return {
    epreuveData,
    loadingData,
    selectedDiscipline,
    register,
    handleSubmit,
    errors,
    setValue,
    reset,
    onSubmit,
    isCreatingExam,
    disciplines,
    generateUrlLoading,
    seletedExam,
    setSeletedExam,
  };
};
